export const draculaNeutral = {
  50: '#EFECF3',
  100: '#E4E1E8',
  200: '#D8D6DD',
  300: '#C5C3CB',
  400: '#A5A3AC',
  500: '#807E87',
  600: '#595760',
  700: '#44424C',
  800: '#36333E',
  900: '#22202B',
  950: '#18161F',
};

export const draculaPrimary = {
  50: '#EAE1FA',
  100: '#DECDFA',
  200: '#CEB5F5',
  300: '#BB98F5',
  400: '#AB7EF2',
  500: '#9C6CEB',
  600: '#8A5ED1',
  700: '#6E4AA8',
  800: '#55348A',
  900: '#412670',
  950: '#342252',
};

export const draculaSecondary = {
  50: '#FAE1EF',
  100: '#FACDE6',
  200: '#F5B5D9',
  300: '#F598CC',
  400: '#F27EC0',
  500: '#EB6CB4',
  600: '#D15E9F',
  700: '#A84A7F',
  800: '#8A3465',
  900: '#702650',
  950: '#52223D',
};

export const draculaError = {
  50: '#FAE1E1',
  100: '#FACDCD',
  200: '#F5B5B5',
  300: '#F59898',
  400: '#F27E7E',
  500: '#EB6C6C',
  600: '#D15E5E',
  700: '#A84A4A',
  800: '#8A3434',
  900: '#702626',
  950: '#522222',
};

export const draculaSuccess = {
  50: '#E1FAE7',
  100: '#CDFAD7',
  200: '#B5F5C4',
  300: '#98F5AD',
  400: '#7EF299',
  500: '#6CEB89',
  600: '#5ED179',
  700: '#4AA860',
  800: '#348A48',
  900: '#267037',
  950: '#22522D',
};

export const draculaWarning = {
  50: '#FAEDE1',
  100: '#FAE3CD',
  200: '#F5D5B5',
  300: '#F5C698',
  400: '#F2B87E',
  500: '#EBAB6C',
  600: '#D1985E',
  700: '#A8794A',
  800: '#8A5F34',
  900: '#704B26',
  950: '#523A22',
};

export const draculaInfo = {
  50: '#E1F5FA',
  100: '#CDF2FA',
  200: '#B5E9F5',
  300: '#98E4F5',
  400: '#7EDDF2',
  500: '#6CD3EB',
  600: '#5EBCD1',
  700: '#4A97A8',
  800: '#347A8A',
  900: '#266370',
  950: '#224952',
};

export const draculaBg = {
  light: '#FAFAF3',
  dark: '#100D13',
};
